//import "babel-polyfill";

require("./bootstrap");

import Vue from "vue";
import axios from "axios";
import Vuex from "vuex";
import VueRouter from "vue-router";
import Vuetify from "vuetify";
import colors from "vuetify/lib/util/colors";
import VuetifyToast from "vuetify-toast-snackbar-ng";
import VueSweetalert2 from "vue-sweetalert2";
import VueChatScroll from 'vue-chat-scroll';
import VueClipboard from 'vue-clipboard2';
import VueQrcodeReader from "vue-qrcode-reader";
import VCurrencyField from 'v-currency-field';
import VueMoment from 'vue-moment';
import CKEditor from 'ckeditor4-vue';
import JsonViewer from 'vue-json-viewer';
import md5 from 'js-md5';

window.Vue = require("vue");

const moment = require('moment');
require('moment/locale/es');
VueClipboard.config.autoSetContainer = true;

Vue.use(VueRouter);
Vue.use(Vuetify);
Vue.use(VuetifyToast, {
    icon: 'mdi-information',
    timeout: 5000,
    closeIcon: 'mdi-close'
});
Vue.use(VueSweetalert2, {
    confirmButtonColor: colors.green.darken3,
    cancelButtonColor: colors.red.darken3,
    showCancelButton: true,
    allowOutsideClick: false,
    allowEscapeKey: false,
    reverseButtons: true
});
Vue.use(VueChatScroll);
Vue.use(VueClipboard);
Vue.use(VueQrcodeReader);
Vue.use(VCurrencyField, {
    locale: 'en-US',
    decimalLength: 2,
    autoDecimalMode: true,
    min: null,
    max: null,
    defaultValue: 0,
    valueAsInteger: false,
    allowNegative: false
});
Vue.use(VueMoment, { moment });
Vue.use(Vuex);
Vue.use(CKEditor);
Vue.use(JsonViewer);
Vue.prototype.$md5 = md5;

import routes from "./routes";
import store from "./store";
import App from "./components/AppComponent";
import Es from './i18n/es';

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior(to, from, savedPosition) {

        // 🔙 Si viene de navegación del navegador (back/forward)
        if (savedPosition) {
            return savedPosition;
        }

        // 🔗 Si hay hash (#section)
        if (to.hash) {
            return {
                selector: to.hash,
                behavior: 'smooth'
            };
        }

        // 🔝 Default
        return { x: 0, y: 0 };
    }
});

router.beforeEach(async (to, from, next) => {
    document.title = (to.meta.title || '') + ' | Valzum';

    if (store.getters['token'] && !store.getters['check']) {
        try {
            await store.dispatch('fetchUser');
        } catch (e) {
            return next({ name: 'Login' });
        }
    }
    const route = reroute(to);

    return next(route || undefined);
});

router.afterEach((to, from) => {
    trackCustomerRoute(to, from);
});

const rules = {
    guest: {
        fail: 'Home',
        check: () => !store.getters['check']
    },
    auth: {
        fail: 'Login',
        check: () => store.getters['check']
    }
};

function reroute(to) {
    let failRoute = false,
        checkResult = true;

    to.meta.rules && to.meta.rules.forEach(rule => {
        let check = false;
        if (Array.isArray(rule)) {
            let checks = [];
            for (let i in rule) {
                checks[i] = rules[rule[i]].check();
                check = check || checks[i];
            }
            if (!check && !failRoute) {
                failRoute = rules[rule[checks.indexOf(false)]].fail;
            }
        } else {
            check = rules[rule].check();
            if (!check && !failRoute) {
                failRoute = rules[rule].fail;
            }
        }

        checkResult = checkResult && check;
    });

    if (!checkResult && failRoute) {
        if (failRoute === 'Login') {
            return {
                name: 'Login',
                query: {
                    to: to.fullPath
                }
            };
        }
        return { name: failRoute };
    }

    return false;
}

function trackCustomerRoute(to, from) {
    const user = store.getters['user'];

    if (!user || user.role !== 'Customer' || !to || (from && to.fullPath === from.fullPath)) {
        return;
    }

    axios.post('/api/activity/page', {
        page: {
            path: to.fullPath,
            name: to.name || '',
            title: to.meta && to.meta.title ? to.meta.title : ''
        }
    }).catch(() => {});
}

export default router;

const darkModeQuery = window.matchMedia('(prefers-color-scheme: dark)');

function themePreference() {
    const saved = localStorage.theme_mode;

    if (['system', 'light', 'dark'].indexOf(saved) !== -1) {
        return saved;
    }

    return localStorage.dark === 'true' ? 'dark' : 'system';
}

function shouldUseDarkMode() {
    const preference = themePreference();

    return preference === 'dark' || (preference === 'system' && darkModeQuery.matches);
}

const vuetifyInstance = new Vuetify({
    breakpoint: {
        scrollBarWidth: 12
    },
    theme: {
        dark: shouldUseDarkMode(),
        options: {
            customProperties: true // 🔥 útil para CSS variables
        },
        themes: {
            light: {
                primary: '#0D93A5',
                secondary: '#DFF1F7',
                tertiary: colors.amber.darken3,
                accent: colors.grey.lighten4,
                info: colors.blue.darken4,
                error: colors.red.darken3,
                success: colors.green.darken3,
                warning: colors.amber.darken1,
                card: '#FFFFFF',
                bg: colors.grey.lighten3,
                disabled: colors.grey.darken4
            },
            dark: {
                primary: '#0D93A5',
                secondary: '#DFF1F7',
                tertiary: colors.amber.darken3,
                accent: colors.grey.darken4,
                info: colors.blue.darken4,
                error: colors.red.darken3,
                success: colors.green.darken3,
                warning: colors.amber.darken1,
                card: '#121212',
                bg: colors.grey.darken3,
                disabled: colors.grey.darken4
            }
        }
    },
    lang: {
        locales: { Es },
        current: 'Es'
    },
    icons: {
        iconfont: 'mdi'
    }
});

/* =========================================
🌗 AUTO DETECTAR CAMBIO DE TEMA DEL SISTEMA
========================================= */

const updateDarkMode = () => {
    vuetifyInstance.framework.theme.dark = shouldUseDarkMode();
};

if (darkModeQuery.addEventListener) {
    darkModeQuery.addEventListener('change', updateDarkMode);
} else if (darkModeQuery.addListener) {
    darkModeQuery.addListener(updateDarkMode);
}

window.addEventListener('valzum-theme-change', updateDarkMode);

/* =========================================
   🚀 APP
========================================= */

export const app = new Vue({
    el: '#app',
    vuetify: vuetifyInstance,
    router,
    store,
    render: h => h(App)
});
